import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { black } from 'app/components/ThemeProvider/colors';
import CloseIcon from 'app/components/Icons/CloseIcon';
import Select from 'react-select';
import {
  calcLabel,
  calcModalPaper,
  calcSelectBox,
  closeBtnBox,
  currencyUpdateInfoBox,
  customStylesCalc,
  dialogTitle,
  dialogTitleBox,
  switchBox,
} from './CurrencyBox.sx';
import SwitchIconHorizontal from 'app/components/Icons/SwitchIconHorizontal';
import AlertIcon from 'app/components/Icons/AlertIcon';
import React, { Dispatch, SetStateAction } from 'react';
import useCurrencyBox from 'app/pages/HomePage/CurrencyBox/useCurrencyBox';
import CalcAmountSelect from 'app/pages/HomePage/CurrencyBox/CalcAmountSelect';

interface CurrencyDataCalc {
  label: string;
  buy: string;
  sell: string;
  text: string;
  value: string;
}

interface Props {
  showCalculator: boolean;
  setShowCalculator: Dispatch<SetStateAction<boolean>>;
  date: string;
  bank: CurrencyDataCalc[];
  cbar: CurrencyDataCalc[];
}

const CalculatorModal = (props: Props) => {
  const { showCalculator, setShowCalculator, date, bank, cbar } = props;
  const {
    t,
    calculateOptions,
    fromCurrency,
    toCurrency,
    bankType,
    handleChangeFrom,
    handleChangeTo,
    valueTo,
    valueFrom,
    onChangeBankType,
    handleSwitchCurrency,
    handleChangeToCurrency,
    handleChangeFromCurrency,
  } = useCurrencyBox({ bank, cbar });

  return (
    <Dialog open={showCalculator} PaperProps={{ sx: calcModalPaper }} onClose={() => setShowCalculator(false)}>
      <DialogTitle sx={dialogTitleBox}>
        <Typography sx={dialogTitle}>{t('homePage.calculator')}</Typography>
        <Button color={'tertiary'} sx={closeBtnBox} onClick={() => setShowCalculator(false)}>
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent sx={{ p: '0' }}>
        <Box sx={{ ...calcSelectBox, mb: '36px' }}>
          <Typography sx={calcLabel}>{t('homePage.source')}</Typography>
          <Select
            components={{
              IndicatorSeparator: () => null,
            }}
            isSearchable={false}
            options={calculateOptions}
            styles={customStylesCalc}
            menuPortalTarget={document.body}
            value={bankType}
            onChange={onChangeBankType}
          />
        </Box>
        <Box sx={{ ...calcSelectBox, mb: '20px' }}>
          <CalcAmountSelect
            value={fromCurrency}
            secondValue={toCurrency}
            valueInput={valueFrom}
            onChangeInput={handleChangeFrom}
            onChange={handleChangeFromCurrency}
            bankType={bankType.value}
            title={t('homePage.sell')}
            options={bankType.value === 'bd' ? bank : cbar}
          />
        </Box>
        <Box sx={switchBox} onClick={handleSwitchCurrency}>
          <SwitchIconHorizontal />
        </Box>
        <Box sx={{ ...calcSelectBox, mb: '28px' }}>
          <CalcAmountSelect
            value={toCurrency}
            secondValue={fromCurrency}
            valueInput={valueTo}
            onChangeInput={handleChangeTo}
            onChange={handleChangeToCurrency}
            bankType={bankType.value}
            title={t('homePage.buy')}
            options={bankType.value === 'bd' ? bank : cbar}
          />
        </Box>
        <Box sx={currencyUpdateInfoBox}>
          <AlertIcon />
          <Typography sx={{ fontSize: '15px', color: black }}>
            {t('homePage.updateDate')}: {date}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CalculatorModal;
